var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4539 20.1715V15.2044C14.4539 14.9848 14.3677 14.7743 14.2143 14.619C14.0609 14.4638 13.8528 14.3765 13.6358 14.3765H10.363C10.146 14.3765 9.93793 14.4638 9.7845 14.619C9.63106 14.7743 9.54486 14.9848 9.54486 15.2044V20.1715C9.54486 20.391 9.45867 20.6016 9.30525 20.7568C9.15183 20.9121 8.94375 20.9993 8.72678 20.9993L3.81828 21C3.71083 21 3.60443 20.9786 3.50515 20.937C3.40587 20.8954 3.31566 20.8344 3.23968 20.7576C3.16369 20.6807 3.10341 20.5894 3.06229 20.489C3.02117 20.3885 3 20.2809 3 20.1722V10.6044C3 10.4891 3.02382 10.375 3.06993 10.2695C3.11604 10.1641 3.18342 10.0695 3.26776 9.9919L11.449 2.46534C11.5996 2.32678 11.7959 2.25001 11.9994 2.25C12.203 2.24999 12.3992 2.32676 12.5498 2.4653L20.7322 9.99189C20.8165 10.0695 20.8839 10.1641 20.9301 10.2695C20.9762 10.375 21 10.4891 21 10.6044V20.1722C21 20.2809 20.9788 20.3885 20.9377 20.489C20.8966 20.5894 20.8363 20.6807 20.7603 20.7576C20.6843 20.8344 20.5941 20.8954 20.4949 20.937C20.3956 20.9786 20.2892 21 20.1817 21L15.272 20.9993C15.055 20.9993 14.847 20.9121 14.6935 20.7568C14.5401 20.6016 14.4539 20.391 14.4539 20.1715V20.1715Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseInactive);
export default __webpack_public_path__ + "static/media/house_inactive.029c5406877ab5404de7434f60d0bc44.svg";
export { ForwardRef as ReactComponent };